function _importBundle(bundleUrl) {
  // babel is giving me guff about dynamic importing
  // from a variable, which we need since the CDN changes
  // for staging and prod. We have to do this hack to please
  // the babel overlords for the time being

  // eslint-disable-next-line no-eval
  return eval(`import('${bundleUrl}')`);
}
export const importBundleMocks = {
  importBundle(bundleUrl) {
    return _importBundle(bundleUrl);
  }
};
export function importBundle(bundleUrl) {
  return importBundleMocks.importBundle(bundleUrl);
}